module.exports = __webpack_public_path__ + "nh-643fd7d520315873a155.svg";